import sampleOne from "../../../assets/body/sampleOne.png";
import sampleTwo from "../../../assets/body/sampleTwo.png";
import sampleThree from "../../../assets/body/sampleThree.png";
import sampleFour from "../../../assets/body/sampleFour.png";
import sampleFive from "../../../assets/body/sampleFive.png";

const images = [
  sampleOne,
  sampleTwo,
  sampleThree,
  sampleFour,
  sampleFive,
];

export default images;
